<template style="background-color:black;">
    <b-container>
        <h1 style="text-align: center">{{ videoID }}</h1>
        <h3 style="text-align: center">{{$ml.get('currentMapConnections')}}</h3>
        <b-row>
            <b-col class="marginaltop"md="8" xs="12">
                <div style="aspect-ratio: 16/9;border:solid 1px black;">
                    <div id="network_container" style="border:solid 1px red;width:100%;height:100%"></div>
                </div>
            </b-col>
            <b-col md="4" xs="12">
                <json-viewer :value="currentNode"></json-viewer>

            </b-col>
        </b-row>
    </b-container>
  </template>
  
  <script>
  import axios from "axios";
  import { Network, DataSet } from 'vis-network/standalone';
import JsonViewer from 'vue-json-viewer'

  export default {
    name: "Map",
    components: {
        JsonViewer,
    },
    data: function () {
      return {
        videoID: "",
        key: "",
        clientView: this.$auth.isAdmin()
            ? this.$auth.getMyClientView() || this.$auth.getMyUser().client
            : this.$auth.getMyUser().client,
        data: {},
        nodes: [],
        edges: [],
        network: null,
        currentNode: {}
      };
    },
    mounted() {
        this.videoID = this.$route.query.videoID;
        this.key = this.$route.query.key;
        this.getInformations();
    },
    methods: {
        getInformations() {
            let req = { 
                url: "https://fr1.quanteec.com:6060/map?id=" + this.videoID + "_" + this.clientView + "_" + this.key,
                method: "get"
            }

            axios(req).then(response => {
                this.data = response.data;
                console.log(this.data);
                this.fillNetworkContainer();
            }).catch(err => {
                console.error(err);
            })
        },
        fillNetworkContainer() {
            // Nodes
            for (let peerID in this.data) {
                let peer = this.data[peerID];
                this.nodes.push({id: peer.id, label: peer.id.split('-').shift()})
            }
            let finalNode = new DataSet(this.nodes);
            // Edges
            for (let peerID in this.data) {
                let peer = this.data[peerID];
                for (let linkIdx in peer.links) {
                    let link = peer.links[linkIdx];
                    let idxLink = this.edges.findIndex(x => x.from === link.id_link && x.to === peer.id);
                    if (idxLink === -1) {
                        this.edges.push({from: peer.id, to: link.id_link, length: 150});
                    }
                }
                
            }
            console.log(this.edges)
            let finalEdge = new DataSet(this.edges);

            var container = document.getElementById("network_container");
            var data = {
                nodes: finalNode,
                edges: finalEdge,
            };
            var options = {};
            this.network = new Network(container, data, options);
            let self = this;
            this.network.on("selectNode", function (params) {
                self.currentNode = self.data[params.nodes[0]];
            });

        }
    },
  };
  </script>